export default {
  menuStart: {
    key: 'menuStart',
    title: 'Start',
    path: '/start'
  },
  menuLogin: {
    key: 'menuLogin',
    title: 'Makler-Login',
    path: '/login'
  },
  menuRegister: {
    key: 'menuRegister',
    title: 'Als neuer Makler registrieren',
    path: '/register'
  }
};
